import { Injectable, signal } from '@angular/core'
import { HttpService } from '@bases/http.service'
import { LocationClass } from '@core/models/location/location.class'
import { Result } from '@core/models/searchbar.model'
import { environment } from '@env/environment'
import * as L from 'leaflet'
import { throwError } from 'rxjs'
import { catchError, finalize, map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class SearchBarService extends HttpService {
  searchLoading$ = signal<boolean>(false)
  protected _baseUrl = 'https://nominatim.openstreetmap.org/search?q='

  geocode(address: string) {
    this.searchLoading$.set(true)
    const countryParam = environment.countryCodes ? `&countrycodes=${environment.countryCodes}` : ''

    return this._http
      .get<
        Result[]
      >(this._baseUrl + encodeURIComponent(address) + `&format=json&polygon=1&addressdetails=1${countryParam}`)
      .pipe(
        map((result) => {
          if (!result || result.length === 0) {
            // throw error because the api returns [] and not an error
            throw new Error('No results found for the provided address.')
          }

          const location = new LocationClass()
          location.address = result[0].display_name
          const lat = parseFloat(result[0].lat)
          const lon = parseFloat(result[0].lon)
          location.latitude = lat
          location.longitude = lon

          const [south, north, west, east] = (result[0].boundingbox || []).map(Number)

          // If it crosses the antemeridian, the results will be within a delta around the point.
          if (Math.abs(east - west) > 180) {
            const delta = 1
            location.viewBounds = L.latLngBounds(
              L.latLng(lat - delta, lon - delta),
              L.latLng(lat + delta, lon + delta),
            )
          } else {
            location.viewBounds = L.latLngBounds(L.latLng(south, west), L.latLng(north, east))
          }

          return location
        }),
        catchError((error) => {
          console.error('Geocode error:', error.message || error)
          return throwError(() => error) // Propagate the error to the subscriber
        }),
        finalize(() => {
          this.searchLoading$.set(false)
        }),
      )
  }
}
